import { Dictionary } from '../../types/dictionary';

export class ApiResourceLocation {
  path?: string | string[];
  queryParams?: Dictionary<unknown>;
  pathParams?: Dictionary<unknown>;
}
